import React, { useState } from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

const CONTACT = [
  { icon: Phone, label: "Phone", value: "+91 98765 43210" },
  { icon: Mail, label: "Email", value: "sales@mattressdirect.in" },
  { icon: MapPin, label: "Address", value: "Manufacturing Unit, Industrial Area, India" },
  { icon: Clock, label: "Hours", value: "Mon - Sat, 9:00 AM - 7:00 PM" },
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email) { toast.error("Please add your name and email."); return; }
    const existing = JSON.parse(localStorage.getItem("enquiries") || "[]");
    existing.push({ ...form, type: "contact", ts: Date.now() });
    localStorage.setItem("enquiries", JSON.stringify(existing));
    toast.success("Message sent! We'll get back to you shortly.");
    setForm({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <div className="bg-white">
      <section className="bg-[#f7f9fc] py-9">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <p className="text-[12px] font-semibold tracking-[0.25em] text-[#f4520b] mb-3">CONTACT US</p>
          <h1 className="font-heading text-4xl font-extrabold text-[#1c2e3a]">Let's Talk Bulk Supply</h1>
          <p className="mt-4 text-slate-600 max-w-2xl">Reach out for quotes, custom requirements or any questions. Our B2B team is here to help.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="grid sm:grid-cols-2 gap-6 content-start">
            {CONTACT.map((c) => (
              <div key={c.label} className="rounded-xl border border-slate-100 shadow-sm p-6">
                <div className="h-11 w-11 rounded-lg bg-[#fff0e9] flex items-center justify-center text-[#1c2e3a] mb-3"><c.icon size={20} /></div>
                <p className="text-[13px] font-semibold text-slate-400 uppercase tracking-wide">{c.label}</p>
                <p className="mt-1 text-[15px] font-medium text-[#1c2e3a]">{c.value}</p>
              </div>
            ))}
          </div>

          <form onSubmit={submit} className="rounded-2xl border border-slate-100 shadow-sm p-7 space-y-4">
            <h3 className="font-heading text-xl font-bold text-[#1c2e3a]">Send us a message</h3>
            <div className="space-y-1.5"><Label>Name *</Label><Input value={form.name} onChange={(e) => update("name", e.target.value)} placeholder="Your name" /></div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="space-y-1.5"><Label>Email *</Label><Input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} placeholder="you@company.com" /></div>
              <div className="space-y-1.5"><Label>Phone</Label><Input value={form.phone} onChange={(e) => update("phone", e.target.value)} placeholder="+91 ..." /></div>
            </div>
            <div className="space-y-1.5"><Label>Message</Label><Textarea value={form.message} onChange={(e) => update("message", e.target.value)} placeholder="How can we help?" rows={4} /></div>
            <Button type="submit" className="w-full bg-[#1c2e3a] hover:bg-[#29424f] text-white h-11 font-semibold">Send Message</Button>
          </form>
        </div>
      </section>
    </div>
  );
}
